export default {
  primary: '#3279be',
  success: '#89c540',
  error: '#f04e3e',
  warning: '#f58518',
  orange: '#f58518',
  'neutral-lighter': '#dee5ed',
  default: '#ffffff'
};
